import { g as getCursorAnimationSpeed } from "./cursor-animation-speed-9bebf13f.js";
const selectors = {
  section: ".js-banner-with-carousel",
  slider: ".js-banner-with-slider-items-container",
  customCursorArea: ".js-banner-with-carousel-custom-cursor-area",
  customCursor: ".js-banner-with-carousel-custom-cursor",
  floatingSlide: ".js-banner-with-carousel-floating-slide",
  activeSlide: ".swiper-slide-active",
  imageLink: ".banner-with-carousel__item-image-link"
};
const cssClasses = {
  isDragging: "is-dragging",
  pulse: "pulse",
  floatingImage: "banner-with-carousel__floating-image",
  activeCursor: "banner-with-carousel__custom-cursor--active",
  sliderReady: "banner-with-carousel__items-container--ready"
};
const DESKTOP_MEDIA_QUERY = "(min-width: 992px)";
const FLOATING_INTRO = {
  DURATION: 550,
  OFFSET_X: 0,
  OFFSET_Y: 0,
  EXTRA_ROTATE_DEG: 0,
  START_SCALE_FACTOR: 1
};
const FLOATING_SCROLL_ANIMATION = {
  FINISH_DISTANCE: 0.8,
  MAX_ROTATION_DEG: 0,
  SCALE_MAX: 1,
  SCALE_MIN: 1,
  EASING_POWER: 1.35,
  DOCK_FADE_DURATION: 200,
  SECTION_START_VIEWPORT_RATIO: 0.35,
  ORIGIN_STAY_PORTION: 0.25
};
const FLOATING_ORIGIN = {
  SECTION_X_RATIO: 0.52,
  SECTION_Y_RATIO: 0.53
};
const CURSOR_CLICK_CONFIG = {
  TAP_MAX_DURATION: 180,
  TAP_MAX_MOVE: 8,
  PULSE_DURATION: 180
};
const BannerWithCarousel = () => {
  var _a, _b;
  const Swiper = (_b = (_a = window.themeCore) == null ? void 0 : _a.utils) == null ? void 0 : _b.Swiper;
  function isDesktopViewport() {
    return window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
  }
  function init(sectionId) {
    const sections = [...document.querySelectorAll(selectors.section)].filter((section) => !sectionId || section.closest(`#shopify-section-${sectionId}`));
    sections.forEach(initSection);
  }
  function initSection(section) {
    const customCursorArea = section.querySelector(selectors.customCursorArea);
    const sliderEl = section.querySelector(selectors.slider);
    const sliderInstance = initSlider(sliderEl);
    handleCursor(customCursorArea, sliderInstance);
    initFloatingSlide(section, sliderEl, sliderInstance);
  }
  function initSlider(sliderEl) {
    if (!sliderEl)
      return null;
    const slides = [...sliderEl.querySelectorAll(".swiper-wrapper > .swiper-slide")];
    const slideCount = slides.length;
    const containerWidth = sliderEl.clientWidth;
    const slideWidths = slides.map((slide) => slide.getBoundingClientRect().width);
    const slidesWidth = slideWidths.reduce((total, width) => total + width, 0);
    const needsEdgeFill = slideCount > 1 && containerWidth > 0 && slidesWidth + 1 < containerWidth;
    const loopedSlides = needsEdgeFill ? getLoopedSlides(slideWidths, containerWidth) : 0;
    const markSliderReady = () => {
      requestAnimationFrame(() => {
        sliderEl.classList.add(cssClasses.sliderReady);
      });
    };
    if (!Swiper) {
      markSliderReady();
      return null;
    }
    try {
      return new Swiper(sliderEl, {
        slidesPerView: "auto",
        centeredSlides: true,
        centeredSlidesBounds: !needsEdgeFill,
        loop: needsEdgeFill,
        rewind: !needsEdgeFill && slideCount > 1,
        loopedSlides,
        loopedSlidesLimit: false,
        speed: 600,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 0.6
        },
        preloadImages: false,
        on: {
          init: markSliderReady
        }
      });
    } catch (error) {
      markSliderReady();
      return null;
    }
  }
  function getLoopedSlides(slideWidths, containerWidth) {
    const groupWidth = slideWidths.reduce((total, width) => total + width, 0);
    if (!slideWidths.length || groupWidth <= 0)
      return slideWidths.length;
    let requiredSlides = 1;
    slideWidths.forEach((activeWidth, activeIndex) => {
      const requiredWidth = Math.max(0, (containerWidth - activeWidth) / 2);
      [1, -1].forEach((direction) => {
        let coveredWidth = 0;
        let count = 0;
        const maxSlides = (Math.ceil(requiredWidth / groupWidth) + 1) * slideWidths.length;
        while (coveredWidth < requiredWidth && count < maxSlides) {
          count += 1;
          const index = (activeIndex + direction * count % slideWidths.length + slideWidths.length) % slideWidths.length;
          coveredWidth += slideWidths[index];
        }
        requiredSlides = Math.max(requiredSlides, count);
      });
    });
    return requiredSlides;
  }
  function handleCursor(area, sliderInstance) {
    if (!area)
      return;
    area.style.cursor = "none";
    const customCursor = area.querySelector(selectors.customCursor);
    const cursorAnimationSpeed = getCursorAnimationSpeed();
    if (!customCursor)
      return;
    let cursorRafId = null;
    let targetX = 0, targetY = 0;
    let currentX = 0, currentY = 0;
    let isPointerInside = false;
    let hasCursorPosition = false;
    let isDragging = false;
    let isLinkPress = false;
    let pressX = 0, pressY = 0, pressTime = 0;
    function updateCursor() {
      currentX += (targetX - currentX) * cursorAnimationSpeed;
      currentY += (targetY - currentY) * cursorAnimationSpeed;
      customCursor.style.left = currentX + "px";
      customCursor.style.top = currentY + "px";
      if (Math.abs(targetX - currentX) < 0.01 && Math.abs(targetY - currentY) < 0.01) {
        cursorRafId = null;
        return;
      }
      cursorRafId = requestAnimationFrame(updateCursor);
    }
    function setCursorPos(event) {
      const rect = area.getBoundingClientRect();
      targetX = event.clientX - rect.left;
      targetY = event.clientY - rect.top;
      if (!hasCursorPosition) {
        currentX = targetX;
        currentY = targetY;
        hasCursorPosition = true;
      }
      if (cursorRafId === null) {
        cursorRafId = requestAnimationFrame(updateCursor);
      }
    }
    function isTapEvent(event) {
      const dt = event.timeStamp - pressTime;
      const moved = Math.hypot(event.clientX - pressX, event.clientY - pressY);
      return dt < CURSOR_CLICK_CONFIG.TAP_MAX_DURATION && moved < CURSOR_CLICK_CONFIG.TAP_MAX_MOVE;
    }
    area.addEventListener("pointerenter", (e) => {
      if (!isDesktopViewport())
        return;
      isPointerInside = true;
      customCursor.classList.add(cssClasses.activeCursor);
      setCursorPos(e);
    }, { passive: true });
    area.addEventListener("pointermove", (e) => {
      if (!isPointerInside)
        return;
      setCursorPos(e);
    }, { passive: true });
    area.addEventListener("pointerleave", () => {
      isPointerInside = false;
      hasCursorPosition = false;
      customCursor.classList.remove(cssClasses.activeCursor);
      if (cursorRafId !== null) {
        cancelAnimationFrame(cursorRafId);
        cursorRafId = null;
      }
    });
    area.addEventListener("pointerdown", (e) => {
      isDragging = true;
      isLinkPress = Boolean(e.target.closest(selectors.imageLink));
      pressX = e.clientX;
      pressY = e.clientY;
      pressTime = e.timeStamp;
      if (!isLinkPress) {
        try {
          area.setPointerCapture(e.pointerId);
        } catch (_) {
        }
      }
      customCursor.classList.add(cssClasses.isDragging);
    });
    area.addEventListener("pointerup", (event) => {
      const wasDragging = isDragging;
      const wasLinkPress = isLinkPress;
      isDragging = false;
      isLinkPress = false;
      customCursor.classList.remove(cssClasses.isDragging);
      try {
        area.releasePointerCapture(event.pointerId);
      } catch (_) {
      }
      const isTap = isTapEvent(event);
      if (wasLinkPress) {
        if (isTap) {
          customCursor.classList.add(cssClasses.pulse);
          setTimeout(() => customCursor.classList.remove(cssClasses.pulse), CURSOR_CLICK_CONFIG.PULSE_DURATION);
        }
        return;
      }
      if (!wasDragging || isTap) {
        const rect = area.getBoundingClientRect();
        const isRight = event.clientX - rect.left > rect.width / 2;
        if (sliderInstance) {
          if (isRight)
            sliderInstance.slideNext();
          else
            sliderInstance.slidePrev();
        }
        customCursor.classList.add(cssClasses.pulse);
        setTimeout(() => customCursor.classList.remove(cssClasses.pulse), CURSOR_CLICK_CONFIG.PULSE_DURATION);
      }
    });
  }
  function initFloatingSlide(section, sliderEl, sliderInstance) {
    const desktopMq = window.matchMedia(DESKTOP_MEDIA_QUERY);
    if (!section || !sliderEl || !desktopMq.matches)
      return;
    const animationDirection = section.dataset.animationDirection || "right";
    const dirSign = animationDirection === "left" ? -1 : 1;
    const originXRatio = animationDirection === "left" ? 1 - FLOATING_ORIGIN.SECTION_X_RATIO : FLOATING_ORIGIN.SECTION_X_RATIO;
    const floatingSlideEl = section.querySelector(selectors.floatingSlide);
    if (!floatingSlideEl)
      return;
    const proxyImg = floatingSlideEl.querySelector("img");
    if (!proxyImg)
      return;
    let activeSlide = sliderEl.querySelector(selectors.activeSlide);
    if (!activeSlide)
      return;
    proxyImg.style.objectPosition = activeSlide.dataset.focalPoint;
    const realImg = activeSlide.querySelector("img");
    const placeholderSvg = activeSlide.querySelector("svg");
    const visualEl = realImg || placeholderSvg;
    if (!visualEl)
      return;
    let proxySvg = floatingSlideEl.querySelector("svg");
    if (realImg && (realImg.currentSrc || realImg.src)) {
      proxyImg.style.display = "";
      proxyImg.src = realImg.currentSrc || realImg.src;
      proxyImg.alt = realImg.alt || "";
      if (proxySvg) {
        proxySvg.remove();
        proxySvg = null;
      }
    } else if (placeholderSvg) {
      proxyImg.style.display = "none";
      if (!proxySvg) {
        proxySvg = placeholderSvg.cloneNode(true);
        proxySvg.classList.add(cssClasses.floatingImage);
        floatingSlideEl.appendChild(proxySvg);
      }
    }
    floatingSlideEl.style.opacity = "0";
    activeSlide.style.transition = "none";
    activeSlide.style.opacity = "0";
    activeSlide.style.visibility = "hidden";
    if (sliderInstance) {
      sliderInstance.allowTouchMove = false;
    }
    let isFinished = false;
    let rafId = null;
    let resizeRafId = null;
    let introStart = null;
    let floatWidth = 0;
    let floatHeight = 0;
    let originXPage = 0;
    let originYPage = 0;
    let sectionStartScroll = 0;
    let resizeObserver = null;
    function recalculateFloatingMetrics() {
      if (sliderInstance) {
        sliderInstance.update();
      }
      const visualRect = visualEl.getBoundingClientRect();
      floatWidth = visualRect.width;
      floatHeight = visualRect.height;
      floatingSlideEl.style.width = `${floatWidth}px`;
      floatingSlideEl.style.height = `${floatHeight}px`;
      const scrollY = window.scrollY || window.pageYOffset || 0;
      const scrollX = window.scrollX || window.pageXOffset || 0;
      const sectionRect = section.getBoundingClientRect();
      const sectionTopPage = sectionRect.top + scrollY;
      const sectionLeftPage = sectionRect.left + scrollX;
      originXPage = sectionLeftPage + sectionRect.width * originXRatio;
      originYPage = sectionTopPage + sectionRect.height * FLOATING_ORIGIN.SECTION_Y_RATIO;
      sectionStartScroll = sectionTopPage - (window.innerHeight || 1) * FLOATING_SCROLL_ANIMATION.SECTION_START_VIEWPORT_RATIO;
    }
    function scheduleRecalculateFloatingMetrics() {
      if (isFinished || !desktopMq.matches || resizeRafId !== null)
        return;
      resizeRafId = requestAnimationFrame(() => {
        resizeRafId = null;
        recalculateFloatingMetrics();
      });
    }
    recalculateFloatingMetrics();
    function cancelFloatingAnimation() {
      if (isFinished)
        return;
      isFinished = true;
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (resizeRafId !== null) {
        cancelAnimationFrame(resizeRafId);
        resizeRafId = null;
      }
      activeSlide.style.transition = "";
      activeSlide.style.opacity = "";
      activeSlide.style.visibility = "";
      floatingSlideEl.style.opacity = "0";
      floatingSlideEl.style.display = "none";
      floatingSlideEl.style.transform = "";
      if (sliderInstance) {
        sliderInstance.allowTouchMove = true;
        sliderInstance.update();
      }
      desktopMq.removeEventListener("change", handleMqChange);
      window.removeEventListener("resize", scheduleRecalculateFloatingMetrics);
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    }
    function handleMqChange(event) {
      if (!event.matches) {
        cancelFloatingAnimation();
      }
    }
    desktopMq.removeEventListener("change", handleMqChange);
    desktopMq.addEventListener("change", handleMqChange);
    window.addEventListener("resize", scheduleRecalculateFloatingMetrics, { passive: true });
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(scheduleRecalculateFloatingMetrics);
      resizeObserver.observe(section);
    }
    function updateAnimation() {
      if (isFinished || !desktopMq.matches)
        return;
      const scrollY = window.scrollY || window.pageYOffset || 0;
      const scrollX = window.scrollX || window.pageXOffset || 0;
      const viewportHeight = window.innerHeight || 1;
      const scrollOffsetFromStart = scrollY - sectionStartScroll;
      if (scrollOffsetFromStart <= 0) {
        floatingSlideEl.style.opacity = "0";
        introStart = null;
        rafId = requestAnimationFrame(updateAnimation);
        return;
      }
      if (introStart === null) {
        introStart = performance.now();
      }
      const denominator = viewportHeight * FLOATING_SCROLL_ANIMATION.FINISH_DISTANCE;
      let scrollProgress = denominator ? scrollOffsetFromStart / denominator : 0;
      if (scrollProgress < 0)
        scrollProgress = 0;
      if (scrollProgress > 1)
        scrollProgress = 1;
      const originStayThreshold = FLOATING_SCROLL_ANIMATION.ORIGIN_STAY_PORTION;
      let travelProgress = 0;
      if (scrollProgress > originStayThreshold) {
        travelProgress = (scrollProgress - originStayThreshold) / (1 - originStayThreshold);
        if (travelProgress < 0)
          travelProgress = 0;
        if (travelProgress > 1)
          travelProgress = 1;
      }
      const easedProgress = Math.pow(travelProgress, FLOATING_SCROLL_ANIMATION.EASING_POWER);
      const originXViewport = originXPage - scrollX;
      const originYViewport = originYPage - scrollY;
      const currentImgRect = visualEl.getBoundingClientRect();
      const targetXViewport = currentImgRect.left + currentImgRect.width / 2;
      const targetYViewport = currentImgRect.top + currentImgRect.height / 2;
      const baseCenterX = originXViewport + (targetXViewport - originXViewport) * easedProgress;
      const baseCenterY = originYViewport + (targetYViewport - originYViewport) * easedProgress;
      const baseRotate = dirSign * FLOATING_SCROLL_ANIMATION.MAX_ROTATION_DEG * (1 - easedProgress);
      const baseScale = FLOATING_SCROLL_ANIMATION.SCALE_MIN + (FLOATING_SCROLL_ANIMATION.SCALE_MAX - FLOATING_SCROLL_ANIMATION.SCALE_MIN) * (1 - easedProgress);
      const now = performance.now();
      const introProgress = Math.max(0, Math.min(1, (now - introStart) / FLOATING_INTRO.DURATION));
      let renderCenterX = baseCenterX;
      let renderCenterY = baseCenterY;
      let renderRotate = baseRotate;
      let renderScale = baseScale;
      let renderOpacity = 1;
      if (introProgress < 1) {
        const introCenterX = baseCenterX + dirSign * FLOATING_INTRO.OFFSET_X;
        const introCenterY = baseCenterY - FLOATING_INTRO.OFFSET_Y;
        const introRotate = baseRotate + dirSign * FLOATING_INTRO.EXTRA_ROTATE_DEG;
        const introScale = baseScale * FLOATING_INTRO.START_SCALE_FACTOR;
        renderCenterX = introCenterX + (baseCenterX - introCenterX) * introProgress;
        renderCenterY = introCenterY + (baseCenterY - introCenterY) * introProgress;
        renderRotate = introRotate + (baseRotate - introRotate) * introProgress;
        renderScale = introScale + (baseScale - introScale) * introProgress;
        renderOpacity = introProgress;
      } else {
        renderOpacity = 1;
      }
      const translateX = renderCenterX - floatWidth / 2;
      const translateY = renderCenterY - floatHeight / 2;
      floatingSlideEl.style.transform = `translate3d(${translateX}px, ${translateY}px, 0) rotate(${renderRotate}deg) scale(${renderScale})`;
      floatingSlideEl.style.opacity = String(renderOpacity);
      if (travelProgress >= 1) {
        dockSlide();
      } else {
        rafId = requestAnimationFrame(updateAnimation);
      }
    }
    function dockSlide() {
      if (isFinished)
        return;
      isFinished = true;
      activeSlide.style.transition = "none";
      activeSlide.style.opacity = "1";
      activeSlide.style.visibility = "visible";
      if (sliderInstance) {
        sliderInstance.allowTouchMove = true;
        sliderInstance.update();
      }
      if (resizeRafId !== null) {
        cancelAnimationFrame(resizeRafId);
        resizeRafId = null;
      }
      desktopMq.removeEventListener("change", handleMqChange);
      window.removeEventListener("resize", scheduleRecalculateFloatingMetrics);
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      requestAnimationFrame(() => {
        floatingSlideEl.style.opacity = "0";
        setTimeout(() => {
          floatingSlideEl.style.display = "none";
          floatingSlideEl.style.transform = "";
        }, FLOATING_SCROLL_ANIMATION.DOCK_FADE_DURATION);
      });
    }
    rafId = requestAnimationFrame(updateAnimation);
  }
  return Object.freeze({ init });
};
const action = () => {
  window.themeCore.BannerWithCarousel = window.themeCore.BannerWithCarousel || BannerWithCarousel();
  window.themeCore.utils.register(window.themeCore.BannerWithCarousel, "banner-with-carousel");
};
if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
